<template>
    <ul class="ContactItems">
        <li v-for="item in ContactData" :key="item.title">
            <div >
               <imgCompifilerComponent :url="item.img" />
            </div> 
            <h5>{{item.title}}</h5>
            <a :href="item.link">{{item.linkTitle}}</a>
        </li>
    </ul>
</template>

<script>
    import imgCompifilerComponent from "./ImgCompnent.vue";
    export default {
        name: "ContactViewComonent",
        props: ['ContactData'],
        mounted() {
            this.addImg()
        },
        methods: {
            addImg() {

            }
        },
        components: {
            imgCompifilerComponent
        }
    }
</script>

<style lang="scss" scoped>
    .ContactItems {
        display: flex;
        flex-wrap: nowrap;
        margin: 0 auto;
        margin-top: 85px;
        margin-left: 200px;
        li {
            width: 425px;
            margin-right: 50px;
            margin-bottom: 40px;
            box-shadow: 0px 0px 50px 5px rgba(126, 126, 126, 0.10196078431372549);

            div {
                width: 90px;
                height: 90px;
                margin: 0 auto;
                margin-left: 166.5px;
                margin-top: 38px;
                border-radius: 50%;
                background-color: #49d6cb;

                img {
                    margin-left: 27px;
                    margin-top: 25px;
                }
            }

            h5 {
                font-size: 24px;
                text-align: center;
                font-weight: 500;
                margin-top: 32px;
            }
            a {
                display: block;
                font-size: 16px;
                color: #49d6cb;
                text-align: center;
                padding: 30px;
                width: 200px;
                margin: 0 auto;
                line-height: 27px;
            }
        }

        li:nth-child(3) {
            div {
                margin-left: 165px;
                img {
                    margin-left: 20px;
                }
            }
        }
         li:nth-child(1) {
            div {
                margin-left: 173px;
                img {
                    margin-left: 32px;
                }
            }
            a {
                width: 250px;
                margin-top: 5px;
            }
        }
    }
    @media only screen and (max-width: 1900px) {
       .ContactItems {
        display: flex;
        flex-wrap: nowrap;
        margin: 0 auto;
        margin-top: 85px;
        margin-left: 00px;
        li {
            width: 425px;
            margin-right: 50px;
            margin-bottom: 40px;
            box-shadow: 0px 0px 50px 5px rgba(126, 126, 126, 0.10196078431372549);

            div {
                width: 90px;
                height: 90px;
                margin: 0 auto;
                margin-left: 40%;
                margin-top: 38px;
                border-radius: 50%;
                background-color: #49d6cb;

                img {
                    margin-left: 27px;
                    margin-top: 25px;
                }
            }

            h5 {
                font-size: 24px;
                text-align: center;
                font-weight: 500;
                margin-top: 32px;
            }
            a {
                display: block;
                font-size: 16px;
                color: #49d6cb;
                text-align: center;
                padding: 30px;
                width: 200px;
                margin: 0 auto;
                line-height: 27px;
            }
        }

        li:nth-child(3) {
            div {
                margin-left: 38%;
                img {
                    margin-left: 20px;
                }
            }
        }
         li:nth-child(1) {
            div {
                margin-top: 50.5px;
                margin-left: 39%;
                img {
                    margin-left: 32px;
                }
            }
            a {
                width: 250px;
                margin-top: 5px;
            }
        }
    } 
    }
    @media only screen and (max-width: 1220px) {
       .ContactItems {
        display: flex;
        flex-wrap: nowrap;
        margin: 0 auto;
        margin-top: 85px;
        margin-left: 0px;
        li {
            width: 350px;
            margin-right: 20px;
            margin-bottom: 20px;
            box-shadow: 0px 0px 50px 5px rgba(126, 126, 126, 0.10196078431372549);
            div {
                width: 90px;
                height: 90px;
                margin: 0 auto;
                margin-left: 35%;
                margin-top: 38px;
                border-radius: 50%;
                background-color: #49d6cb;

                img {
                    margin-left: 27px;
                    margin-top: 25px;
                }
            }

            h5 {
                font-size: 24px;
                text-align: center;
                font-weight: 500;
                margin-top: 32px;
            }
            a {
                display: block;
                font-size: 16px;
                color: #49d6cb;
                text-align: center;
                padding: 30px;
                width: 200px;
                margin: 0 auto;
                line-height: 27px;
            }
        }

        li:nth-child(3) {
            div {
                margin-left: 35%;
                img {
                    margin-left: 20px;
                }
            }
        }
         li:nth-child(1) {
            div {
                margin-top: 50.5px;
                margin-left: 35%;
                img {
                    margin-left: 32px;
                }
            }
            a {
                width: 250px;
                margin-top: 5px;
            }
        }
    } 
    }
    @media only screen and (max-width: 800px) {
        .ContactItems {
                display: flex;
                justify-content: center;
                flex-wrap: wrap!important;

                li {
                    width: 280px;
                    margin: 5px;
                    box-shadow: 0px 0px 50px 5px rgba(126, 126, 126, 0.10196078431372549);

                    div {
                        width: 90px;
                        height: 90px;
                        margin: 0 auto;
                        margin-top: 20px;
                        border-radius: 50%;
                        background-color: #49d6cb;

                        img {
                            margin-left: 27px;
                            margin-top: 25px;
                        }
                    }

                    h5 {
                        font-size: 24px;
                        text-align: center;
                        font-weight: 500;
                        margin-top: 20px;
                    }

                    p {
                        font-size: 16px;
                        color: #49d6cb;
                        text-align: center;
                        padding: 30px;
                    }
                }

                li:nth-child(3) {
                    div {
                        img {
                            margin-left: 20px;
                        }
                    }
                }
        }
    }
</style>